"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function dataSourcesMatch(first, second) {
  var firstFingerprint = first ? first.getFingerprint() : null;
  var secondFingerprint = second ? second.getFingerprint() : null;
  return firstFingerprint === secondFingerprint;
}

exports.dataSourcesMatch = dataSourcesMatch;